define('modules/profiles/subviews/views/profile.salesforce.export.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "semantic",
    'modules/profiles/models/salesforce.lead.model',
    'modules/profiles/models/salesforce.contact.model',
    'modules/profiles/models/salesforce.accounts.model',
    'modules/base/views/base.view',
    "text!modules/profiles/subviews/templates/profile.salesforce.export.template.html"
], function(
    Prospector,
    $, _,Backbone,
    Semantic,
    SalesforceLeadModel,
    SalesforceContactModel,
    SalesforceAccountsModel,
    BaseView,
    Template
){
    var SalesforceExportSubView = BaseView.extend({
        className: 'col-md-6 salesforceExportDrawer',
        template: _.template(Template),
        mainBtnLoaderRestingText: 'Export',
        mainBtnLoaderWorkingText: 'Exporting',
        initialize: function(options) {
            this.parent = options.parent;
            this.accounts = null;
        },
        mEvents:function(){
            return {
                'change .useInferredEmail' : 'procUseInferredEmail'
            };
        },
        onRender:function(){
            // if(Prospector.SettingsApp.hasSkrapp()){
            //     this.$('.hasSkrapp').show();
            // }
            $('.pageTitle').html(this.parent.model.get('firstName') + ' ' + this.parent.model.get('lastName'));
            var that = this;
            var dropdownValue = "lead";
            var dropdownText = "Lead";
            if(this.parent.model.salesForceData.get('accountId')!= ""){
                dropdownValue = "contact";
                dropdownText = "Contact";
            }
            this.$('.typeSelector').dropdown({
                forceSelection: false,
                onChange:function () {
                    $.proxy(that.procTypeSelector, that)();
                }
            }).dropdown('set value', dropdownValue).dropdown('set text', dropdownText);
            BaseView.prototype.onRender.call(this);
            this.procTypeSelector();
        },
        procUseInferredEmail:function(){
            var checked = this.$('.useInferredEmail').prop('checked');
            if(checked){
                this.$('.inferredField').slideDown();
            } else {
                this.$('.inferredField').slideUp();
            }
        },
        getSalesForceExportType:function(){
            return this.$('.typeSelector').dropdown('get value');
        },
        procTypeSelector:function () {
            switch (this.getSalesForceExportType()){
                case 'lead':{
                    this.$('.leadInfo').show();
                    this.$('.contactInfo').hide();
                    this.$('.exportReady').show();
                    break;
                }
                case 'contact':{
                    this.$('.leadInfo').hide();
                    this.$('.contactInfo').show();
                    this.$('.exportReady').hide();
                    var dropdownValue = "0";
                    var dropdownText = "Select account";
                    if(this.parent.model.salesForceData.get('accountId')!= ""){
                        dropdownText = this.parent.model.salesForceData.get("accountName");
                        dropdownValue = this.parent.model.salesForceData.get('accountId');
                        //this.$(this.mainBtnLoaderTextSelector).html("Update Contact");
                    }
                    if(this.accounts == null){
                        var that = this;
                        this.accounts = this.$('.accounts').dropdown({
                            apiSettings: {
                                url: 'https://app.relpro.com/prospector/v1/salesforce/accounts',
                                method : 'GET',
                                dataType: 'json',
                                contentType: "application/json; charset=utf-8",
                                saveRemoteData: false,
                                cache: false,
                                onResponse: function(response) {
                                    var mResponse = {
                                        results: [
                                        ]
                                    };
                                    if(response != undefined && response.accounts !=undefined && response.accounts.length > 0) {
                                        _.each(response.accounts, function (account) {
                                            mResponse.results.push({
                                                name: account.name,
                                                value: account.accountId
                                            });
                                        });
                                    }
                                    //query
                                    return mResponse;
                                },
                                beforeSend: function(settings) {
                                    // form data is editable in before send
                                    that.$('.accounts .menu').empty();

                                    var obj = {};
                                    obj.query = that.$('.accounts input.search').val();

                                    settings.data = obj;

                                    return settings;
                                }
                            },
                            onChange: function(value, text){
                                /*if(that.parent.model.salesForceData.get('accountId')!= "" && that.parent.model.salesForceData.get('accountId') == value){
                                 that.$(that.mainBtnLoaderTextSelector).html("Update Contact");
                                 } else if(that.parent.model.salesForceData.get('accountId')!= ""){
                                 that.$(that.mainBtnLoaderTextSelector).html(that.mainBtnLoaderRestingText + " as a New Contact");
                                 }*/
                            }
                        }).dropdown('set value', dropdownValue).dropdown('set text',  dropdownText);
                    }
                    break;
                }
            }
        },
        procMainBtn:function(){
            this.errOut('');
            var accuracy = "0";
            var checked = Prospector.SettingsApp.hasSkrapp() && this.$('.useInferredEmail').prop('checked');
            if(checked){
                accuracy = this.$('.accuracy').val();
                if(isNaN(accuracy)){
                    this.errOut('Please enter a valid number for the minimum accuracy.');
                    this.removeMainBtnLoader();
                    return null;
                }
            }
            switch (this.getSalesForceExportType()){
                case 'lead':{
                    this.model = new SalesforceLeadModel();
                    this.model.set({
                        "rcpId": this.parent.model.get('id'),
                        "inferEmail": checked,
                        "minInferredAccuracy": checked ? parseInt(accuracy) : 0,
                        "source": {
                            "sourceId": this.parent.model.get('source').sourceId,
                            "refId": this.parent.model.get('source').refId
                        }
                    });
                    break;
                }
                case 'contact':{
                    var acctId = this.$('.accounts').dropdown('get value');
                    if(acctId == "0"){
                        this.errOut('Please select a valid account from your Salesforce instance.');
                        this.removeMainBtnLoader();
                        return null;
                    }
                    this.model = new SalesforceContactModel();
                    this.model.set({
                        "rcpId": this.parent.model.get('id'),
                        "accountId": acctId,
                        "inferEmail": checked,
                        "minInferredAccuracy": checked ? parseInt(accuracy) : 0,
                        "source": {
                            "sourceId": this.parent.model.get('source').sourceId,
                            "refId": this.parent.model.get('source').refId
                        }
                    });
                    if(this.parent.model.salesForceData.get('accountId')!= "" && this.parent.model.salesForceData.get('accountId') == acctId){
                        this.model.set({
                            "id": this.parent.model.get('id')
                        });
                    }
                    break;
                }
            }
            this.model.once('sync', this.mainBtnResponse, this);
            this.currXHR = this.model.save();
        },
        errOut:function(msg){
            if(msg == ""){
                this.$('.hasError').hide();
            } else {
                this.$('.hasError').show();
                this.$('.error').html(msg);
            }
        },
        procMainBtnResponse:function(){
            if(this.model.isValid()){
                this.parent.model.salesForceData.attributes = [];
                this.parent.model.salesForceData.set(this.model.attributes);
                this.successOut("The profile has been uploaded to salesforce.");
                /*if(this.getSalesForceExportType() == "contact"){
                 this.$(this.mainBtnLoaderTextSelector).html("Update Contact");
                 }*/
            } else {
                this.errOut(this.model.errorMessage);
            }
        }
    });
    return SalesforceExportSubView;
});
